var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":'Manage delegates access'}},[_c('manage-participants',{attrs:{"task-id":_vm.taskId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }